export enum MilestoneProgressStatus {
  pending = 0,
  inProgress = 1,
  done = 2,
  completed = 3
}
